require('./brokerInterveniersView.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');


// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @actions
const brokerIntervenersActions = require('actions/brokerInterveners');

// @components
const BrokerInterveniersInterveniersTable = require('components/broker/brokerInterveniersInterveniersTable/brokerInterveniersInterveniersTable');
const BrokerInterveniersInvestment = require('components/broker/brokerInterveniersInvestment/brokerInterveniersInvestment');

// @constants
const { TYPE_FUNDS, MYPROFILE_BROKER_URL } = require('constants/index');

class BrokerInterveniersView extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.getInterveners();
    }

    getAssociateAccount() {
        const { type } = this.props.match.params;
        const { accounts } = this.props;
        const accountsIds = accounts.get('byId');
        const { brokerInterveners } = this.props;

        const emptyResult = {
            balance: {
                amount: '',
                currency: ''
            }
        };

        let wallet,
            walletIban;

        if (type !== TYPE_FUNDS) {
            walletIban = brokerInterveners.get('iban');
        } else {
            wallet = this.getWalletId().get('cuentaAsociada')
        }

        const associatedAccount = accountsIds.find(value => {
            if (type === TYPE_FUNDS) {
                return wallet.get('subgrupo') === value.get('product') && wallet.get('numerodecontrato') === value.get('contractNumber');
            } else {
                return walletIban === value.getIn(['ibanComplex', 'codbban']);
            }
        });

        return associatedAccount ? associatedAccount.toJS() : emptyResult;
    }

    getBreadcrumb() {
        const mappingBreadcrumb = [];
        const { type } = this.props.match.params;
        const breadcrumbBrokerInvestiments = formatText('breadcrumb-brokerInvestments');
        const breadcrumbIntervenier = formatText('broker-interveniersContractInterveniers');
        const breadcrumbIntervenierFund = formatText('broker-interveniersContractInterveniersFund');

        mappingBreadcrumb.push({
            text: breadcrumbBrokerInvestiments,
            url: MYPROFILE_BROKER_URL
        })

        if (type == TYPE_FUNDS) {
            mappingBreadcrumb.push({
                text: breadcrumbIntervenierFund,
                url: ''
            })
        } else {
            mappingBreadcrumb.push({
                text: breadcrumbIntervenier,
                url: ''
            })
        }

        return mappingBreadcrumb;
    }

    getCondition(item, product, contractNumber) {
        return (
            item.getIn(['contrato', 'producto']) === product &&
            item.getIn(['contrato', 'numerodecontrato']) === contractNumber
        );
    }

    getContentBoxInfo() {
        const { brokerInterveners } = this.props;
        const { type } = this.props.match.params;
        const userInvestmentsContracts = this.getUserInvestmentsContracts();
        const wallet = this.getWalletId();
        const associateAccount = this.getAssociateAccount();
        let owner, intervenerType, contractValues;
        if (type === TYPE_FUNDS) {
            const immIntervenerList = brokerInterveners.get('list');
            const immOwner = !!immIntervenerList
              ? immIntervenerList.find(immInterveener => {
                  const intervenerType = immInterveener.get('tipoIntervencion');
                  return intervenerType && intervenerType.trim() === 'TITULAR';
                })
              : null;
            owner =
              !!immOwner && !!immOwner.get('nomInterviniente')
                ? immOwner.get('nomInterviniente')
                : userInvestmentsContracts.get('nombretitular');
            intervenerType = userInvestmentsContracts.getIn(
              ['descIntervenciones', 'nomTipInterv'],
              '-- '
            );
            contractValues = wallet;
        } else {
            owner = userInvestmentsContracts.get('owner');
            intervenerType = userInvestmentsContracts.get('intervenerType');
            contractValues = this.getContractValues();
        }
        let info = {
            name: wallet.get('name'),
            owner: owner,
            intervenerType: intervenerType,
            contractValues: contractValues,
            associateAccount: associateAccount,
            type: type
        };

        return info;
    }

    getContractValues() {
        const { brokerWallets } = this.props;
        const { id } = this.props.match.params;
        return brokerWallets.get('walletList')
            .find(item => item.get('fullContractNumber') === id.slice(0, 8) +
                item.getIn(['account', 'digitodecontrol']) + id.slice(8, 18));
    }

    getInterveners() {
        const { type } = this.props.match.params;
        this.props.getIndexes(this.getWalletId(), type);
    }

    getTitle() {
        const { type } = this.props.match.params;
        let pageTitle = "";

        if (type == TYPE_FUNDS) {
            pageTitle = "broker-interveniersContractInterveniersFund";

        } else {
            pageTitle = "broker-interveniersContractInterveniers";
        }

        return pageTitle;
    }

    getUserInvestmentsContracts() {
        const { userInvestmentsContracts } = this.props;
        const { id, type } = this.props.match.params;
        if (type === TYPE_FUNDS) {
            const product = id.slice(0, 3);
            const contractNumber = id.slice(3);
            return userInvestmentsContracts.get('funds').find(fund =>
                this.getCondition(fund, product, contractNumber)
            );
        } else {
            const product = id.slice(8, 11);
            const contractNumber = id.slice(11);
            return userInvestmentsContracts.get('values').find(value =>
                this.getCondition(value, product, contractNumber)
            );
        }
    }

    getWalletId() {
        const { brokerWallets } = this.props;
        const { id, type } = this.props.match.params;
        if (type === TYPE_FUNDS) {
            const product = id.slice(0, 3);
            const contractNumber = id.slice(3);
            return brokerWallets.get('fundsList').find(fund =>
                this.getCondition(fund, product, contractNumber)
            );
        } else {
            const product = id.slice(8, 11);
            const contractNumber = id.slice(11);
            return brokerWallets.get('walletList').find(value =>
                this.getCondition(value, product, contractNumber)
            );
        }
    }

    render() {
        const { brokerInterveners } = this.props;

        const contentInfo = this.getContentBoxInfo();
        return (
            <div className="broker-interveniers-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.getBreadcrumb()}
                        finalTitle={getFinalTitle(this.getTitle())}
                    />
                </OKCover>
                <section className="broker-interveniers-view__body">
                    <div className="row no-outside-gutter">
                        <section className="col-xs-8">
                            <BrokerInterveniersInterveniersTable brokerInterveners={brokerInterveners} />
                        </section>
                        <section className="col-xs-4">
                            <BrokerInterveniersInvestment contentInfo={contentInfo} brokerInterveners={brokerInterveners} />
                        </section>
                    </div>
                </section>
            </div>
        );
    }

}

BrokerInterveniersView.propTypes = {
    match: PropTypes.object.isRequired,
    getIndexes: PropTypes.func.isRequired,
    brokerInterveners: PropTypes.object,
    brokerWallets: PropTypes.object,
    accounts: PropTypes.object,
    userInvestmentsContracts: PropTypes.object
};

module.exports.constructor = BrokerInterveniersView;
module.exports.BrokerInterveniersView = withRouter(connect(
    state => ({
        brokerInterveners: state.brokerInterveners,
        brokerWallets: state.brokerWallets,
        userInvestmentsContracts: state.userInvestmentsContracts,
        accounts: state.accounts
    }), {
    getIndexes: brokerIntervenersActions.getIndexes
}
)(BrokerInterveniersView));
